<template lang="pug">
    .rank
        el-table(:data="mixinItems" style="width: 100%" size="mini" @row-click="rowClick")
            //- el-table-column(type="index" label="排名")
            el-table-column(prop="name" label="名称")
            el-table-column(prop="code" label="代码")
                template(slot-scope="scope")
                    | {{scope.row.code.replace(/[a-zA-Z]+/, '')}}
            el-table-column(prop="close_price" label="收盘价")
                template(slot-scope="scope")
                    strong(:class="+scope.row.change >= 0 ? 'red' : 'green'") &yen;{{(scope.row.close_price).toFixed(2)}}

            el-table-column(prop="latest_price" label="最新价")
                template(slot-scope="scope")
                    strong(:class="+scope.row.change >= 0 ? 'red' : 'green'") &yen;{{(scope.row.latest_price).toFixed(2)}}

            el-table-column(prop="change" label="价格变动")
                template(slot-scope="scope")
                    strong(:class="+scope.row.change >= 0 ? 'red' : 'green'") &yen;{{(scope.row.change).toFixed(2)}}

            el-table-column(prop="percent" label="百分比")
                template(slot-scope="scope")
                    | {{(scope.row.percent).toFixed(2)}}%
            el-table-column(prop="volume" label="成交量")
                template(slot-scope="scope")
                    | {{scope.row.volume | fmtTradeNumber}}
</template>

<script>
import listMixin from './list-mixin.vue';
import intervalMixin from './interval-mixin.vue';

export default {
    name: 'StockIndex',
    mixins: [listMixin, intervalMixin],
    props: { param: Object },
    data() {
        return {
            mixinSize: 5,
        };
    },
    watch: {
        param() {
            this.mixinGetList();
        },
    },
    computed: {
        mixinUrl() {
            if (this.param.order_by && this.param.order)
                return `v2/finance/stock/rank?order_by=${this.param.order_by}&order=${this.param.order}`;
            return 'v2/finance/stock/rank?order_by=percent&order=desc';
        },
    },
    created() {},
    methods: {
        mixinIntervalMethods() {
            this.mixinGetList();
        },

        rowClick({ code }) {
            this.$router.push(`/stock/${code}`);
        },
    },
    filters: {
        fmtTradeNumber(value) {
            let unit = '股';
            if (value >= 1e6) {
                value = value / 1e6;
                unit = '万手';
            } else if (value >= 100) {
                value = value / 100;
                unit = '手';
            }
            return value.toFixed(2) + unit;
        },
    },
};
</script>

<style lang="stylus" scoped>
.rank-item
    margin-bottom 10px
    font-size 12px
    span
        margin-right 10px
.green
    color green
.red
    color red
</style>
